const unauthorizedTranslations = {
  en: {
    pageTitle: "Unauthorized",
    heading: "Access Denied",
    message: "You do not have permission to view this page.",
    homeBtn: "Go to Home",
  },
  pa: {
    pageTitle: "ਅਧਿਕਾਰ ਨਹੀਂ",
    heading: "ਪਹੁੰਚ ਰੋਕ ਦਿੱਤੀ ਗਈ ਹੈ",
    message: "ਤੁਹਾਨੂੰ ਇਹ ਪੰਨਾ ਵੇਖਣ ਦੀ ਇਜਾਜ਼ਤ ਨਹੀਂ ਹੈ।",
    homeBtn: "ਮੁੱਖ ਪੰਨੇ 'ਤੇ ਜਾਓ",
  },
};

export default unauthorizedTranslations;
